import { ICellRendererComp, ICellRendererParams } from "ag-grid-community";
import { formatMessage } from "lib/globalize-util";
import { ISortOrder } from "../../../tool-panels";
import { TotalTypes } from "../pinned-row-constants";
import { ASSORTMENT_TOTALS_ROW } from "../pinned-row-helpers";
import { createMarkup } from "lib/helpers";

interface IProps extends ICellRendererParams {
    displayPlanMetrics?: boolean;
    displayTotals?: boolean;
    onClick?: () => void;
}

class RollupLabelCell implements ICellRendererComp {
    declare eGui: HTMLElement;

    private getLabel(params: IProps) {
        const totalType = params.data?.totalType;
        let totalTypeLabel = "";
        if (totalType === TotalTypes.Units) {
            totalTypeLabel = formatMessage("Units");
        } else if (totalType === TotalTypes.Wholesale) {
            totalTypeLabel = formatMessage("Cost");
        } else if (totalType === TotalTypes.Retail) {
            totalTypeLabel = formatMessage("Retail");
        } else if (totalType === TotalTypes.Skus) {
            totalTypeLabel = formatMessage("Products");
        } else if (totalType === TotalTypes.Depth) {
            totalTypeLabel = formatMessage("Avg Depth");
        } else if (totalType === TotalTypes.AvgWholesale) {
            totalTypeLabel = formatMessage("Avg Cost");
        } else if (totalType === TotalTypes.AvgRetail) {
            totalTypeLabel = formatMessage("AUR");
        } else if (totalType === ASSORTMENT_TOTALS_ROW) {
            totalTypeLabel = formatMessage("Totals");
        }
        return totalTypeLabel;
    }

    private buildValueElement(params: IProps) {
        // create the cell
        if (!this.getGui()) {
            this.eGui = document.createElement("div");
            this.eGui.className = "planHeader";
            this.eGui.onclick = params.data.onClick;
        } else {
            this.getGui().innerHTML = "";
        }
        const metricType = document.createElement("div");
        metricType.className = "planTitle";
        metricType.innerHTML = createMarkup(this.getLabel(params));
        this.eGui.appendChild(metricType);

        if (params.data.pinnedRowSorts?.length) {
            const pinnedRowSort = params.data.pinnedRowSorts[0];
            if (pinnedRowSort.id === params.data.totalType) {
                const icon = document.createElement("span");
                icon.classList.add("ag-icon");
                icon.classList.add("ag-header-icon");
                icon.classList.add(`ag-icon-${pinnedRowSort.order === ISortOrder.Ascending ? "asc" : "desc"}`);
                this.eGui.appendChild(icon);
            }
        }
    }

    refresh(params: IProps): boolean {
        // Static cell. Do nothing on refresh.
        this.buildValueElement(params); // Got to rebuild the whole GUI
        return true;
    }
    getGui(): HTMLElement {
        return this.eGui;
    }
    destroy(): void {
        // No-op
    }
    init(params: IProps) {
        this.buildValueElement(params);
    }
}

export { RollupLabelCell };
